/**
 * Base path for the app when served under a subpath (e.g. /thesis behind nginx).
 * Set REACT_APP_BASE_PATH=/thesis (and PUBLIC_URL=/thesis for build) when deploying under a prefix.
 * All API requests, static assets, and router use this.
 */
export const BASE_PATH = process.env.REACT_APP_BASE_PATH || "";

/** Returns path prefixed with base path (e.g. /thesis/api/auth). Use for API URLs and static paths. */
export function withBasePath(path) {
  const base = BASE_PATH.replace(/\/$/, "");
  const p = path.startsWith("/") ? path : `/${path}`;
  return base ? `${base}${p}` : p;
}
